export const GET_INSPECTIONS= 'GET_INSPECTIONS';
export const GET_INSPECTIONS_SUCCESS = 'GET_INSPECTIONS_SUCCESS';
export const GET_INSPECTIONS_FAILED = 'GET_INSPECTIONS_FAILED';